import { openBlock as e, createElementBlock as l, createStaticVNode as d } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 96 96"
}, o = /* @__PURE__ */ d('<path fill="#6DE86A" d="M8.695 23.496v49.57h78.609v-49.57z"></path><path fill="#0D141F" fill-rule="evenodd" d="M8 73.762V22.8h80v50.962zm1.392-1.391h77.217V24.19H9.392z" clip-rule="evenodd"></path><path fill="#fff" d="m18.095 42.301-.017 11.945 20.533.029.017-11.945z"></path><path fill="#0D141F" fill-rule="evenodd" d="m17.383 54.941.018-13.336 21.925.03-.019 13.337zm1.393-1.39 19.142.027.014-10.553-19.141-.027z" clip-rule="evenodd"></path><path fill="#0D141F" fill-rule="evenodd" d="m26.156 41.598 4.39.017-.013 13.346h-4.377zm1.392 1.397V53.57h1.595l.01-10.568z" clip-rule="evenodd"></path><path fill="#0D141F" fill-rule="evenodd" d="M38.615 48.977H18.07v-1.392h20.545z" clip-rule="evenodd"></path><path fill="#fff" d="m23.22 45.295-.01 5.972 10.273.014.009-5.972z"></path><path fill="#0D141F" fill-rule="evenodd" d="m22.516 51.962.01-7.364 11.664.017-.01 7.363zm1.393-1.39 8.881.013.006-4.58-8.88-.013z" clip-rule="evenodd"></path>', 8), h = [
  o
];
function i(n, p) {
  return e(), l("svg", t, [...h]);
}
const f = { render: i };
export {
  f as default,
  i as render
};
